import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/Observable";

@Injectable()
export class ChartService {

  constructor(private http: HttpClient) {

  }
  getCharts(index): Observable<any> {
    return this.http.get('https://rest.vipfe.gob.bo/reportes/grafico/' + index);
  }
  getData(): Observable<any> {
    return this.http.get('https://rest.vipfe.gob.bo/reportes/detalleInstitucional');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/chart/chart-service.ts